import { Wifi, WifiOff, Loader2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

/**
 * Small badge that surfaces a dashboard SSE connection's state
 * (`useDashboardStream` returns exactly these three values). Shared across the
 * admin screens that subscribe to the live stream so a silently-dead connection
 * is always visible — never mistaken for a working one.
 */
export function LiveStatusPill({ status }: { status: 'connecting' | 'live' | 'offline' }) {
  if (status === 'live') {
    return (
      <Badge variant="outline" className="gap-1.5 border-green-300 bg-green-50 text-green-700">
        <Wifi className="w-3 h-3 animate-pulse" />
        Live
      </Badge>
    )
  }
  if (status === 'connecting') {
    return (
      <Badge variant="outline" className="gap-1.5 border-amber-300 bg-amber-50 text-amber-700">
        <Loader2 className="w-3 h-3 animate-spin" />
        Connecting
      </Badge>
    )
  }
  return (
    <Badge variant="outline" className="gap-1.5 border-border bg-muted text-muted-foreground">
      <WifiOff className="w-3 h-3" />
      Offline
    </Badge>
  )
}
